import { useLoadingWheelStyles } from './LoadingWheel.styles';
import { mergeClasses } from '@fluentui/react-components';

export interface ILoadingWheelProps {
    className?: string;
}

const LoadingWheel = (props: ILoadingWheelProps) => {
    const styles = useLoadingWheelStyles();

    return <div className={mergeClasses(styles.loader, styles.animation, props.className)}></div>;
};

export default LoadingWheel;
